import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../../images/logo6.png'
import Practices from '../../api/Practices';

const SubmitHandler = (e) => {
    e.preventDefault()
}

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    return (
        <footer className="relative bg-[#151a30] z-10">
            <div className="pt-[100px] pb-[90px] md:py-[90px] md:pb-[20px] overflow-hidden relative -z-10">
                <div className="wraper">
                    <div className="grid grid-cols-4 md:grid-cols-2 sm:grid-cols-1 gap-3">
                        <div className="w-[420px] xl:w-[355px] lg:w-[297px] pr-[125px] md:mb-[40px] lg:pr-0 relative text-left">
                            <div className="mb-7">
                                <Link className="text-[45px] font-bold flex items-center text-white" to="/">
                                    <img src={Logo} alt="" /></Link>
                            </div>
                            <p className="text-white text-[16px] mb-[10px]">
                                GAVA-<i>Lex</i>, votre avocat de confiance, allie expérience et expertise pour défendre vos droits avec professionnalisme et conviction.
                            </p>
                            {/* <ul className="overflow-hidden pt-[15px]">
                                <li className="text-white float-left group "><Link className="text-white transition-all group-hover:text-[#FFE600]" onClick={SubmitHandler} to="/"><i className="ti-facebook"></i></Link></li>
                                <li className="text-white float-left group ml-[15px]"><Link className="text-white transition-all group-hover:text-[#c0b596]" onClick={SubmitHandler} to="/"><i className="ti-twitter-alt"></i></Link></li>
                                <li className="text-white float-left group ml-[15px]"><Link className="text-white transition-all group-hover:text-[#c0b596]" onClick={SubmitHandler} to="/"><i className="ti-linkedin"></i></Link></li>
                                <li className="text-white float-left group ml-[15px]"><Link className="text-white transition-all group-hover:text-[#c0b596]" onClick={SubmitHandler} to="/"><i className="ti-pinterest"></i></Link></li>
                                <li className="text-white float-left group ml-[15px]"><Link className="text-white transition-all group-hover:text-[#c0b596]" onClick={SubmitHandler} to="/"><i className="ti-vimeo-alt"></i></Link></li>
                            </ul> */}
                        </div>
                        <div className="w-[200px] md:w-full ml-auto md:mb-[40px] lg:pr-0 relative text-left ">
                            <div className="mb-7">
                                <h3 className="text-[28px] font-medium  font-heading-font text-white capitalize">Liens rapides</h3>
                            </div>
                            <ul>
                                <li className="relative mb-[8px] block"><Link className=" text-white hover:text-[#c0b596] transition-all" to="/home">Accueil</Link></li>
                                <li className="relative mb-[8px] block"><Link className=" text-white hover:text-[#c0b596] transition-all" to="/equipe">L'équipe</Link></li>
                                <li className="relative mb-[8px] block"><Link className=" text-white hover:text-[#c0b596] transition-all" to="/matieres">Matières</Link></li>
                                <li className="relative mb-[8px] block"><Link className=" text-white hover:text-[#c0b596] transition-all" to="/honoraires">Honoraires</Link></li>
                                <li className="relative mb-[8px] block"><Link className=" text-white hover:text-[#c0b596] transition-all" to="/news">Actualités</Link></li>
                                <li className="relative mb-[8px] block"><Link className=" text-white hover:text-[#c0b596] transition-all" to="/contact">Contact</Link></li>
                            </ul>
                        </div>
                        <div className="pl-[15px] md:pl-[0px] md:mb-[40px] lg:pr-0 relative text-left ">
                            <div className="mb-7">
                                <h3 className="text-[28px] font-medium  font-heading-font text-white capitalize">Matières</h3>
                            </div>
                            <ul>
                                {Practices.map((practice, Pitem) => (
                                    <li className="relative mb-[8px] block" key={Pitem}><Link className="text-white hover:text-[#c0b596] transition-all" onClick={ClickHandler} to={`/matieres/${practice.slug}`}>{practice.sTitle}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className=" md:mb-[40px] lg:pr-0 relative text-left ">
                            <div className="mb-7">
                                <h3 className="text-[28px] font-medium  font-heading-font text-white capitalize">Contactez-nous</h3>
                            </div>
                            <ul>
                                <li className="relative mb-[8px] block text-white">Bd Frans Dewandre 6</li>
                                <li className="relative mb-[8px] block text-white">6000 Charleroi</li>
                                <li className="relative mb-[8px] block text-white">Belgique</li>
                                <li className="relative mb-[8px] block text-white">&nbsp;</li>
                                <li className="relative mb-[8px] block text-white">Téléphone : +32 (0) 71.70.02.02</li>
                                <li className="relative mb-[8px] block text-white">E-mail: secretariat@gava-lex.be</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wraper">
                <div className=" border-t-1 border-[rgba(192,181,150,.3)] relative">
                    <div className="h-[1px] absolute left-[15px] top-0 bg-[#ffffff0d] w-[calc(100%+30px)]"></div>
                    <p className="text-center text-white text-[14px] py-[20px]">
                    
                    &copy; <span id="currentYear">{new Date().getFullYear()}</span> GAVA-<i>Lex</i>. Tous droits réservés | <Link to='/confidentialite' className=" text-white hover:text-[#c0b596] transition-all">Politique de protection des données</Link> | Développé par <Link to='https://www.one-o-one.be' target='_blank' className=" text-white hover:text-[#c0b596] transition-all"><strong>ONE-O-ONE</strong></Link></p>
                </div>
            </div>
        </footer>
    )
}

export default Footer;